import React, { useState, useEffect } from 'react'
import GoogleMapReact from 'google-map-react'
import { setFirstAndLastIndex } from '../ResultsList/resultsUtils.js'
import {
  getMapBounds,
  generatePinLocations,
  setInitialMapCenter,
} from './mapUtils.js'
import LocationPin from './LocationPin.jsx'
import './ClinicMap.scss'

let myMap = null
let googleMaps = null
// let bufferTimer = null;

const pinsToCenterOnLimit = 5 // when we're centering the map on the given clinics, only look at the first X of them

const DESKTOP_BREAK_POINT = 1024

const ClinicMap = ({
  lexicon,
  sortedAndFilteredClinics, // full list of clinics
  cardDisplayState,
  updateCardDisplayState,
  sliderRef,
  googleMapsApiKey,
}) => {
  const [isRecenterButtonVisible, setIsRecenterButtonVisible] = useState(false)
  //   const [_windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [isOpeningMoblileMap, setIsOpeningMoblileMap] = useState(false)

  const [firstClinicIndex, lastClinicIndex] = setFirstAndLastIndex(
    cardDisplayState.isMobileMapOpen,
    cardDisplayState.activePageNum
  )
  const clinicsToShow = sortedAndFilteredClinics.slice(
    firstClinicIndex,
    lastClinicIndex
  )
  const selectedCardIndex =
    cardDisplayState.selectedClinicIndex === null
      ? undefined
      : parseInt(cardDisplayState.selectedClinicIndex) - firstClinicIndex
  const isSelectedClinicValid =
    selectedCardIndex !== null && selectedCardIndex < clinicsToShow.length

  //   [> map config <]

  const pinLocations = generatePinLocations(clinicsToShow)
  const mapCenter = setInitialMapCenter(pinLocations, selectedCardIndex)

  // [> Handlers <]

  //   const onMapResizeThrottle = () => {
  //     if (bufferTimer) clearTimeout(bufferTimer);

  //     bufferTimer = setTimeout(() => {
  //       if (window.innerWidth >= 860) {
  // updateCardDisplayState({isMobileMapOpen: false})
  //       }
  //       setWindowHeight(window.innerHeight); // purely for triggering map re-render
  //     }, 200);
  //   };

  const centerFivePins = () => {
    const clinicsToCenterOn = clinicsToShow.slice(0, pinsToCenterOnLimit)
    const newPinLocations = generatePinLocations(clinicsToCenterOn)
    const bounds = getMapBounds(myMap, googleMaps, newPinLocations)

    myMap.fitBounds(bounds)
    setIsRecenterButtonVisible(false)
  }

  const centerActivePin = () => {
    if (!clinicsToShow.length) return

    let activeClinicLatLng

    if (isSelectedClinicValid) {
      const activeClinic = clinicsToShow[selectedCardIndex]
      // console.log('== configuring', 'clinicsToShow', clinicsToShow, 'selectedCardIndex', selectedCardIndex)
      activeClinicLatLng = new window.google.maps.LatLng(
        activeClinic.lat,
        activeClinic.lng
      )
    } else if (cardDisplayState.focusedPinIndex !== null) {
      const focusedLatLng = clinicsToShow[cardDisplayState.focusedPinIndex]
      activeClinicLatLng = new window.google.maps.LatLng(
        focusedLatLng.lat,
        focusedLatLng.lng
      )
    } else {
      activeClinicLatLng = new window.google.maps.LatLng(
        clinicsToShow[0].lat,
        clinicsToShow[0].lng
      )
    }

    myMap.panTo(activeClinicLatLng)
    setIsRecenterButtonVisible(false)
  }

  const areLocationsInView = (locationArr, map) => {
    // console.log('locationArr', locationArr)
    if (!locationArr[0]) return false

    const currentBounds = map.getBounds()
    let output = true

    for (let i = 0; i < locationArr.length; i += 1) {
      if (
        !currentBounds.contains(
          new window.google.maps.LatLng(locationArr[i].lat, locationArr[i].lng)
        )
      ) {
        output = false
        break
      }
    }

    return output
  }

  const setZoomToIncludeFivePinsWithSetCenter = () => {
    if (isSelectedClinicValid) {
      // console.log('centering active pin')
      const activeClinic = clinicsToShow[selectedCardIndex]
      const activeClinicLatLng = new window.google.maps.LatLng(
        activeClinic.lat,
        activeClinic.lng
      )
      const clinicsToCheck = clinicsToShow.slice(
        selectedCardIndex,
        selectedCardIndex + 5
      )

      let currentZoom = 11
      let isZoomSufficient = false
      myMap.setCenter(activeClinicLatLng)

      while (!isZoomSufficient && currentZoom > 0) {
        myMap.setZoom(currentZoom)
        isZoomSufficient = areLocationsInView(clinicsToCheck, myMap)

        if (!isZoomSufficient) currentZoom -= 1
      }
    }
  }

  const onGoogleApiLoad = ({ map, maps, _places }) => {
    myMap = map
    googleMaps = maps
    // if (!selectedCardIndex) centerFivePins();
  }

  const configureRecenterButtonVisibility = () => {
    const currentBounds = myMap.getBounds()
    let activeClinicLatLng

    if (isSelectedClinicValid) {
      const activeClinic = clinicsToShow[selectedCardIndex]
      activeClinicLatLng = new window.google.maps.LatLng(
        activeClinic.lat,
        activeClinic.lng
      )
    } else
      activeClinicLatLng = new window.google.maps.LatLng(
        clinicsToShow[0].lat,
        clinicsToShow[0].lng
      )

    if (currentBounds.contains(activeClinicLatLng))
      setIsRecenterButtonVisible(false)
    else setIsRecenterButtonVisible(true)
  }

  //   [> useEffects <]

  //   useEffect(() => {
  //     window.addEventListener('resize', onMapResizeThrottle, true);
  //     return () => {
  //       window.removeEventListener('resize', onMapResizeThrottle, true);
  //     };
  //   }, []);

  //   // redo bounds when clinic list is changed
  useEffect(() => {
    if (sortedAndFilteredClinics.length > 0 && myMap && !selectedCardIndex) {
      centerFivePins()
    }
  }, [sortedAndFilteredClinics.length, cardDisplayState.activePageNum, myMap])

  // (MOBILE ONLY) when we select a card, center the map on its corresponding pin
  useEffect(() => {
    if (cardDisplayState.isMobileMapOpen && myMap) {
      // first time opening
      if (isOpeningMoblileMap) {
        setZoomToIncludeFivePinsWithSetCenter()
        setIsOpeningMoblileMap(false)

        // mobile map already open
      } else if (
        // if the active pin is not in view, center to it
        cardDisplayState.selectedClinicIndex &&
        !areLocationsInView(
          [clinicsToShow[cardDisplayState.selectedClinicIndex]],
          myMap
        )
      ) {
        centerActivePin()
      }
    }
  }, [cardDisplayState.selectedClinicIndex])

  useEffect(() => {
    if (myMap) {
      // when we open mobile map, auto select the first card of that would be on the list view
      if (cardDisplayState.isMobileMapOpen) {
        if (!cardDisplayState.selectedClinicIndex) {
          const clinicIndex = (cardDisplayState.activePageNum - 1) * 5
          sliderRef.current.slickGoTo(clinicIndex, false)
          setIsOpeningMoblileMap(true)
        } else {
          sliderRef.current.slickGoTo(
            cardDisplayState.selectedClinicIndex,
            false
          )
        }

        // when we close mobile map
      } else {
        centerFivePins()

        updateCardDisplayState({
          selectedClinicIndex: null,
          focusedPinIndex: null,
        })
      }
    }
  }, [cardDisplayState.isMobileMapOpen])

  return (
    <div className="ClinicMap" style={{ height: window.innerHeight }}>
      {isRecenterButtonVisible && (
        <button
          className="recenter"
          type="button"
          onClick={() => centerActivePin()}
        >
          {lexicon.get('recenter')}
        </button>
      )}

      <GoogleMapReact
        // we already load Google Maps outside of GoogleMapReact to do distance sorting ... ok to ignore warning
        bootstrapURLKeys={{ key: googleMapsApiKey }}
        defaultZoom={11}
        center={mapCenter}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={onGoogleApiLoad}
        onChildClick={(key) => {
          const clinicIndex = firstClinicIndex + parseInt(key)
          if (window.innerWidth >= DESKTOP_BREAK_POINT) {
            updateCardDisplayState({
              selectedClinicIndex: clinicIndex,
              focusedPinIndex: clinicIndex,
            })
          } else {
            sliderRef.current.slickGoTo(clinicIndex, false) // let slider handle setting selected clinic
          }
        }}
        onDragEnd={() => {
          // since we're unable to block the drag when controlled by google maps, just select the open box after any kind of drag
          if (cardDisplayState.selectedClinicIndex !== null) {
            window
              .getSelection()
              .selectAllChildren(
                document.getElementById(
                  `location-pin-hover-box-${cardDisplayState.selectedClinicIndex}`
                )
              )
          }
          configureRecenterButtonVisibility()
        }}
        onZoomAnimationEnd={configureRecenterButtonVisibility}
        onClick={(e) => {
          // below is a hacky way to check, did the user click on a pin or the rest of the map ?
          if (e.event.target.nodeName === e.event.currentTarget.nodeName) {
            updateCardDisplayState({ selectedClinicIndex: null })
          } else {
            // click info in a pin hover box to select it for copy+paste
            window.getSelection().selectAllChildren(e.event.target)
          }
        }}
        options={{
          gestureHandling: 'greedy', // Will capture all touch events on the map towards map panning
          clickableIcons: false,
        }}
      >
        {pinLocations.map((location, i) => {
          const index = firstClinicIndex + i

          return (
            <LocationPin
              lat={location.lat} // Magic prop: used by GoogleMapReact
              lng={location.lng} // Magic prop: used by GoogleMapReact
              isFocused={
                cardDisplayState.focusedPinIndex === index ||
                selectedCardIndex === index ||
                cardDisplayState.hoveringClinicIndex === index
              }
              isShowingInfoBox={
                cardDisplayState.selectedClinicIndex === index ||
                cardDisplayState.hoveringClinicIndex === index
              }
              onMouseEnter={() =>
                updateCardDisplayState({ hoveringClinicIndex: index })
              }
              onMouseLeave={() =>
                updateCardDisplayState({ hoveringClinicIndex: -1 })
              }
              number={firstClinicIndex + 1 + i}
              name={location.name}
              address={location.address}
              hoverBoxID={`location-pin-hover-box-${i}`}
              // eslint-disable-next-line react/no-array-index-key
              key={i}
            />
          )
        })}
      </GoogleMapReact>
    </div>
  )
}

export default ClinicMap
